import React, { useState } from 'react';
import { AddKitchenRequestType } from 'models/kitchen-request';

const KitchenRequestPreview = ({
  formData,
  onEdit
}: {
  formData: AddKitchenRequestType[];
  onEdit: () => void;
}) => {
  const [showDetails, setShowDetails] = useState<Record<number, boolean>>({});

  const toggleDetails = (index: number) => {
    setShowDetails((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div>
      <div className='flex justify-end'>
        <button
          onClick={onEdit}
          className='text-sm text-red-5 hover:text-red-6 -mb-8 relative bottom-16'>
          {formData.length === 1 ? 'Edit' : 'Edit All'}
        </button>
      </div>
      {formData.map((data, index) => (
        <div key={index}>
          <div className='flex justify-between border-b border-b-[#EAEBEB] bg-[#F7F7F7E5] px-2 py-6 gap-6 items-center'>
            <div>
              <p className='font-medium text-[#2E3031] capitalize'>{data.ingredient_name}</p>
              <p className='font-medium text-[#6F7376] capitalize'>
                {data.quantity} {data.item_type}
              </p>
            </div>
            {data.items && data.items.length > 0 && (
              <button
                className='rounded-xl bg-white border px-2 text-sm border-[#5E6164]'
                onClick={() => toggleDetails(index)}>
                {showDetails[index] ? 'Hide' : 'Show'}
              </button>
            )}
          </div>

          {showDetails[index] && data.items && data.items.length > 0 && (
            <ul className='flex flex-col gap-2 px-2 '>
              {data.items.map((item, itemIndex) => (
                <li
                  key={item.id}
                  className={`flex items-center gap-3 py-3 text-sm text-[#5E6164] ${
                    itemIndex < (data.items?.length ?? 0) - 1 ? 'border-b border-b-[#EAEBEB]' : ''
                  }`}>
                  <span className='font-semibold text-sm text-[#5E6164]'>
                    {item.ingredient.name}
                  </span>
                  <span className='w-1 h-1 rounded-full bg-[#D9D9D9]'></span>
                  {data.no_of_portions && (
                    <span className='text-[#6F7376]'>
                      {((item.quantity * Number(data.quantity)) / data.no_of_portions).toFixed(2)}{' '}
                      {item.ingredient.unit_type}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default KitchenRequestPreview;
